var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gift-content"},[_c(_vm.component,{ref:"component",tag:"component",on:{"getData":function (data) { return _vm.$emit('getData', data); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }